var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg113(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2532_2619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 24H13.4062C16.1199 24 18.3281 21.7449 18.3281 19.0312C18.3281 16.3176 16.1199 14.1094 13.4062 14.1094H10.5938C7.88011 14.1094 5.67188 16.3176 5.67188 19.0312C5.67188 21.7449 7.88011 24 10.5938 24ZM9.39352 18.5341C9.66816 18.2595 10.1131 18.2595 10.3878 18.5341L11.2969 19.4432L13.6123 17.1278C13.8869 16.8532 14.3319 16.8532 14.6065 17.1278C14.8812 17.4025 14.8812 17.8475 14.6065 18.1221L11.794 20.9346C11.5194 21.2093 11.0744 21.2093 10.7998 20.9346L9.39352 19.5284C9.11883 19.2537 9.11883 18.8088 9.39352 18.5341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 11.2969V12C5.67188 12.3883 5.98669 12.7031 6.375 12.7031H17.625C18.0133 12.7031 18.3281 12.3883 18.3281 12V11.2969C18.3281 10.5202 17.6985 9.89062 16.9219 9.89062H7.07812C6.30145 9.89062 5.67188 10.5202 5.67188 11.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4152 8.48438L14.097 2.34009C14.1052 2.26388 14.1094 2.18766 14.1094 2.10938C14.1094 0.946219 13.1632 0 12 0C10.8368 0 9.89062 0.946219 9.89062 2.10938C9.89062 2.18902 9.89475 2.2673 9.90366 2.34558L10.5852 8.48438H13.4152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2532_2619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg113);
export default __webpack_public_path__ + "static/media/svg113.3cecb3c930eda9580057655394ad04fa.svg";
export { ForwardRef as ReactComponent };